import { uploadMethods } from '@/state/helpers';
import { showMessage } from '@/utils/messages';
import { CONFIG_MORE, validateVideoFile } from '@/components/Editor/constants';

export default {
    data() {
        return {
            loadingMessage: '',
            configModalProgress: { ...CONFIG_MORE.configModalProgress },
            currentPollInterval: null
        };
    },
    methods: {
        ...uploadMethods,

        async baseHandleUploadVideo(file, initialResult = {}) {
            // Validation: Sử dụng configEditor (Editor) hoặc config (Upload component)
            const config = this.configEditor || this.config;
            const { isValid, errorType, maxSizeMB } = await validateVideoFile(file, config);

            if (!isValid) {
                let message = '';
                if (errorType === 'FORMAT') message = this.$t('uploadFile.format');
                if (errorType === 'SIZE') message = this.$t('uploadFile.maxSizeMovie', { size: maxSizeMB });
                showMessage(8080, this.$bvToast, message || 'File không hợp lệ');
                return null;
            }
            this.configModalProgress.model = true;
            this.loadingMessage = this.$t('uploadFile.alertProcess');
            try {
                const formData = new FormData();
                formData.append('video', file);
                const response = await this.acUploadVideo(formData);
                if (response?.code === 200) {
                    const jobId = response?.data?.id;
                    const resultData = { ...initialResult, ...response.data };
                    if (jobId) {
                        return await this.startPollingVideoStatus(jobId, resultData);
                    } else {
                        return this.finishVideoProcess(resultData);
                    }
                } else {
                    this.failVideoProcess(this.$t(response?.message || 'system.error'));
                    return null;
                }
            } catch (error) {
                console.error('Upload error:', error);
                this.failVideoProcess(this.$t(error?.message || 'system.error'));
                return null;
            }
        },

        async startPollingVideoStatus(jobId, resultData) {
            let attempts = 0;
            const maxAttempts = 120; // 10 minutes
            const intervalTime = 5000;
            return new Promise((resolve) => {
                this.currentPollInterval = setInterval(async () => {
                    attempts++;
                    try {
                        const res = await this.acgetJobStatusFile(jobId);
                        if (res?.data?.status === 1) {
                            const finalData = { ...resultData, ...res.data };
                            this.finishVideoProcess(finalData, resolve);
                        } else if (res?.data?.status === 2) {
                            this.failVideoProcess('Video processing failed', resolve);
                        }
                    } catch (e) {
                        console.error('Polling error:', e);
                    }
                    if (attempts >= maxAttempts) {
                        this.failVideoProcess('Video processing timeout', resolve);
                    }
                }, intervalTime);
            });
        },

        finishVideoProcess(resultData, resolve) {
            this.clearPollInterval();
            this.loadingMessage = this.$t('uploadFile.videoProcessSuccess');
            setTimeout(() => {
                this.configModalProgress.model = false;
                this.loadingMessage = '';
                if (resolve) resolve(resultData);
            }, 800);
        },

        failVideoProcess(message, resolve) {
            this.clearPollInterval();
            showMessage(8080, this.$bvToast, message);
            this.configModalProgress.model = false;
            this.loadingMessage = '';
            if (resolve) resolve(null);
        },

        clearPollInterval() {
            if (this.currentPollInterval) {
                clearInterval(this.currentPollInterval);
                this.currentPollInterval = null;
            }
        }
    },
    beforeDestroy() {
        this.clearPollInterval();
    }
};
